import React from 'react'
import {Modal} from "react-bootstrap"


function ModalVideo(props) {
    return (
      <Modal
        show={props.show}
        onHide={() => props.handleclose()}
        centered
        size="lg"
      >
        <div className="p-xl-4 p-xxl-5">
          <Modal.Header closeButton>
            <Modal.Title>How to use ORLEN chargers</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div class="embed-responsive embed-responsive-16by9">
              <iframe
                title="How to use ORLEN chargers"
                class="embed-responsive-item"
                src="https://video.orlen.pl/DlaKier/Orlen%20-%20animacja%20bez%20RFID%20-%20rekawiczki.mp4"
                id="video"
                allowscriptaccess="always"
                allow="autoplay"
              ></iframe>
            </div>
          </Modal.Body>
        </div>
      </Modal>
    )
}

export default ModalVideo
